export default {
  appName: 'ELN Fahrzeug Manager',
  logo: '/ELN-logo.png',
  logoLight: '/ELN-logo-white.png',
  primary: '#7CB621',
};
